<template>
<div class="row">
  <app-overlay-loader v-if="preloader" />
  <!-- <div class="col-sm-12 col-md-12 breadcrumb-side-button">
    <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
      <button
        type="button"
        class="btn btn-primary btn-with-shadow"
        data-toggle="modal"
        @click="assignForm">
        {{ $t("assign_form") }}
      </button>
    </div>
  </div> -->

  <div class="col-sm-12 col-md-12">
    <el-form v-if="active === 1">
      <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
        <button
          type="button"
          class="btn btn-primary btn-with-shadow"
          data-toggle="modal"
          @click="assignForm">
          {{ $t("assign_form") }}
        </button>
      </div>
      <myjob-review :id="$attrs['props'].id"></myjob-review>
    </el-form>

    <el-form v-if="active === 2">
      <div class="card-body">
          <form
              ref="form"
              data-url="/admin/task/store"
              class="mb-sm-0"
              id="task_form"
              :class="{ 'loading-opacity': preloader }"
              >
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="form-group">
                    <label>{{ $t("forms") }}</label>
                    <app-input
                      type="search-select"
                      :isAnimatedDropdown="true"
                      :placeholder="$t('forms')"
                      :list="this.forms"
                      v-model="inputs.form_id"
                    />
                    <p v-if="refreshShow == false" class="font-italic text-muted">
                      {{ $t("shortcut_form_create") }} <span><a href="#" @click.prevent="createForm()">{{$t("create_new")}}</a></span>
                    </p>
                    <p v-if="refreshShow == true" class="font-italic text-muted">
                      <a href="#" @click.prevent="refreshForm()">{{$t("refresh")}}</a><span> {{ $t("form_create_refresh") }}</span>                    </p>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="form-group">
                    <label>{{ $t("title") }}</label>
                    <app-input type="text" v-model="inputs.title" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label>{{ $t("description") }}</label>
                    <app-input
                      type="textarea"
                      id="textarea-id"
                      :label="$t('message_placeholder')"
                      v-model="inputs.description"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="form-group">
                    <label>{{ $t("start_date") }}</label>
                    <app-input
                      type="date"
                      v-model="inputs.start_date"
                      :placeholder="$t('select_valid_date')"
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="form-group">
                    <label>{{ $t("due_date") }}</label>
                    <app-input
                      type="date"
                      v-model="inputs.due_date"
                      :placeholder="$t('select_valid_date')"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label>{{ $t("priority") }}</label>
                    <app-input
                      type="radio"
                      :list="list"
                      v-model="inputs.priority"
                    />
                  </div>
                </div>
              </div>
              <div class="mt-5 action-buttons">
                  <button
                  type="submit"
                  class="btn btn-primary mr-2"
                  @click.prevent="formAssign"
                  >
                  {{ $t("submit") }}
                  </button>
                  <button
                  type="submit"
                  class="btn btn-secondary"
                  @click.prevent="previous"
                  >
                  {{ $t("back") }}
                  </button>
              </div>
          </form>
      </div>
    </el-form>

  </div>

</div>
</template>

<script>
import {
  BUYER_CERTIFICATE_FORMS,
  BUYER_CERTIFICATE_FORM_ASSIGN,
  JOB_FORM_ASSIGN,
  COMPANY_JOB_GET,
} from "../../../../../Config/ApiUrl";
import { axiosGet, axiosPost } from "../../../../../Helpers/AxiosHelper";
import AppLibrary from "../../../../../Helpers/AppLibrary";
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin";

export default {
  name: "CompanyProfileView",
  extends: AppLibrary,
  mixins: [FormMixin],

  data() {
    return {
      refreshShow: false,
      active: 1,
      preloader: true,
      company: {},
      inputs: {},
      forms: [],
      list: [
        {
          id: "high",
          value: "High",
        },
        {
          id: "medium",
          value: "Medium",
        },
        {
          id: "low",
          value: "Low",
        },
      ],
    };
  },
  methods: {
    assignForm() {
      this.active = 2;
    },
    previous() {
      this.active = 1;
    },
    formAssign() {
        this.preloader = true;
        // BUYER_CERTIFICATE_FORM_ASSIGN
        this.inputs.type = 'review';
        if (this.inputs.start_date) this.inputs.start_date = this.getDateFormatForBackend(this.inputs.start_date);
        if (this.inputs.due_date) this.inputs.due_date = this.getDateFormatForBackend(this.inputs.due_date);
        axiosPost(JOB_FORM_ASSIGN, this.inputs)
          .then((res) => {
            this.$toastr.s(res.data.message);
            this.previous();
          })
          .catch((error) => {
            
          }).finally(() => {
            this.inputs = {};
            this.preloader = false;
          });
    },

    getForms() {
      axiosGet(BUYER_CERTIFICATE_FORMS)
        .then((res) => {
          this.forms = res.data;
        })
        .catch((error) => {
          
        });
    },
    getCustomerJob() {
      // this.preloader = true;
      // let myLocation = location.href;
      // let split = myLocation.split("/");
      // let id = split[6].split("?")[0];
      let id = this.$attrs['props'].id;
      this.inputs.job_id = id;
      //   
      axiosGet(COMPANY_JOB_GET + "/" + id)
        .then((response) => {
          // this.job = response.data;
          
          this.inputs.start_date = response.data.start_date;
          this.inputs.due_date = response.data.end_date;
          
        })
        .catch((error) => {
          
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    refreshForm() {
      this.refreshShow = false;
      this.getForms();

    },
    createForm() {
      this.refreshShow = true;
      window.open('/admin/documentlibrary/mydocument', '_blank');
    },
  },
  mounted() {
    this.getForms();
    this.getCustomerJob();
  },
};
</script>
